<template>
  <div v-if="totalCount > perPage" class="receipt-pagination mt-4">

    <div class="receipt-pagination mt-4">
      <div class="receipt-pagination mt-4">
        <b-pagination v-model="pageNum"
                      :total-rows="totalCount"
                      :per-page="perPage"
                      align="center"
                      @input="changePage">
        </b-pagination>
      </div>
    </div>

    <div v-if="totalCount > 0">
      <div class="text-center small text-info">
        Total documents: <b>{{ totalCount }}</b>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    props: {
      perPage: {
        type: Number,
        default: function () {
          return 0;
        }
      },
      totalCount: {
        type: Number,
        default: function () {
          return 0;
        }
      }
    },

    data() {
      return {
        pageNum: 1
      };
    },

    methods: {
      changePage: async function (value) {
        const from = (value * this.perPage) - (this.perPage - 1);
        this.$emit('changePage', from);
      },

      setPage: function (filter) {
        if (!filter || filter.from === 1) {
          this.pageNum = 1;
        }
      }
    }
  };
</script>

<style lang="stylus">


</style>
